import { render, staticRenderFns } from "./ClipEditor.vue?vue&type=template&id=db65462a&"
import script from "./ClipEditor.vue?vue&type=script&lang=js&"
export * from "./ClipEditor.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports